export const getImageUrl = (imageName: string, baseUrl = 'https://d3i5fgga1gz9lq.cloudfront.net/') => {
    return `${baseUrl}fit-in/1200x1200/filters:no_upscale()/${imageName}`;
}

export const getLargeImageUrl = (imageName: string, baseUrl = 'https://d3i5fgga1gz9lq.cloudfront.net/') => {
    return `${baseUrl}fit-in/2000x2000/filters:no_upscale()/${imageName}`;
}
